module.exports = __webpack_public_path__ + "statics/img/cate10-1@2x.d40db733.png";